<template>
  <div class="demo--source-label">
    {{ label }}
    <div class="chevron" style="">
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      source: String
    },
    data() {
      return {
        label: null,
      };
    },
    mounted() {
      console.log(this.source);
      this.label = this.source;
      /* switch (this.source) {
         case "page":
           this.label = "Contest";
           break;
         case null:
         this.label = "Contest";
         break;
         case "":
         this.label = "Contest";
         break;
         default: 
           this.label = "Contest";
         break;
       }*/
    },
  };
</script>